import React, { useState, useRef } from "react";
import { useIntersection } from "../../_hooks";

export function MarkerSearchResult({ markerType, onMarkerClick }) {
  const [inView, setInView] = useState(false);
  const imgRef = useRef();

  useIntersection(imgRef, () => {
    setInView(true);
  });

  const handleResultClick = () => {
    if (onMarkerClick) onMarkerClick(markerType);
  };
  return (
    <div
      className="chronos-marker-template-search-result"
      onClick={handleResultClick}
      ref={imgRef}
    >
      <div
        className="chronos-marker-template-icon"
        // style={{ paddingBottom: "100%" }}
      >
        {inView && (
          <img
            src={`https://www.worldanvil.com/${markerType.path}`}
            // style={{ width: 48, height: 48 }}
            alt=""
          />
        )}
      </div>
      <div className="chronos-marker-template-name">{markerType.name}</div>
    </div>
  );
}
